import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export function AdminRoute({ children }) {
  const location = useLocation();
  const { isAuthenticated, isAuthLoading, user } = useAuth();

  if (isAuthLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center px-4">
        <div className="rounded-[28px] border border-[#efd9e4] bg-white px-6 py-8 text-center shadow-sm">
          <p className="text-sm font-semibold text-[#7b6170]">Checking admin access...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!user?.is_admin) {
    return (
      <div className="flex min-h-[70vh] items-center justify-center px-4">
        <div className="max-w-xl rounded-[32px] border border-[#f0dce7] bg-white p-8 text-center shadow-[0_18px_50px_rgba(86,43,66,0.08)]">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#fff0f7] text-[#c33276]">
            <ShieldAlert size={28} />
          </div>
          <h1 className="mt-5 text-2xl font-black text-[#291c26]">Admin access required</h1>
          <p className="mt-3 text-sm leading-6 text-[#735f6d]">
            This area is reserved for administrators. End users should not be able to view or
            manage template metadata here.
          </p>
        </div>
      </div>
    );
  }

  return children;
}

export default AdminRoute;
